import { useResetAtom } from 'jotai/utils'
import { useUnmount } from 'react-use'

import {
  brandIdsAtom,
  commentByViewKeyAtom,
  dataDisplayTypeAtom,
  importanceQuestionIdAtom,
  isTabulationFetchingAtom,
  isTabulationReadyAtom,
  lastTabulationParamsAtom,
  liftSaQuestionIdAtom,
  npiDriverQuestionIdAtom,
  pendingScrollHashAtom,
  savedCommentByViewKeyAtom,
  segmentDisplayTypeAtom,
  selectedRouteAtom,
  tabulatedBrandIdsAtom,
  tabulationDataAtom,
  whoAndWhatAwaitIdAtom,
} from '../atoms'

import { npiDriverDataAtom } from './useNpiDriverTableData'

export const useResetOnUnmount = () => {
  const resetDataDisplayType = useResetAtom(dataDisplayTypeAtom)
  const resetSegmentDisplayType = useResetAtom(segmentDisplayTypeAtom)
  const resetBrandIds = useResetAtom(brandIdsAtom)
  const resetTabulatedBrandIds = useResetAtom(tabulatedBrandIdsAtom)
  const resetNpiDriverQuestionId = useResetAtom(npiDriverQuestionIdAtom)
  const resetImportanceQuestionId = useResetAtom(importanceQuestionIdAtom)
  const resetLiftSaQuestionId = useResetAtom(liftSaQuestionIdAtom)
  const resetIsTabulationReady = useResetAtom(isTabulationReadyAtom)
  const resetIsTabulationFetching = useResetAtom(isTabulationFetchingAtom)
  const resetLastTabulationParams = useResetAtom(lastTabulationParamsAtom)
  const resetTabulationData = useResetAtom(tabulationDataAtom)
  const resetWhoAndWhatAwaitId = useResetAtom(whoAndWhatAwaitIdAtom)
  const resetSelectedRoute = useResetAtom(selectedRouteAtom)
  const resetPendingScrollHash = useResetAtom(pendingScrollHashAtom)
  const resetNpiDriverData = useResetAtom(npiDriverDataAtom)
  const resetComment = useResetAtom(commentByViewKeyAtom)
  const resetSavedComment = useResetAtom(savedCommentByViewKeyAtom)

  useUnmount(() => {
    resetDataDisplayType()
    resetSegmentDisplayType()
    resetBrandIds()
    resetTabulatedBrandIds()
    resetNpiDriverQuestionId()
    resetImportanceQuestionId()
    resetLiftSaQuestionId()
    resetIsTabulationReady()
    resetIsTabulationFetching()
    resetLastTabulationParams()
    resetTabulationData()
    resetWhoAndWhatAwaitId()
    resetSelectedRoute()
    resetPendingScrollHash()
    resetNpiDriverData()
    resetComment()
    resetSavedComment()
  })
}
